
import Vue from "vue";
import { ExactService, IExactStatus } from "@/services/exact-service";
import { ClearfactsService, IClearfactsStatus } from "@/services/clearfacts-service";
import { AccountantService, IAccountantDossier } from "@/services/accountant-service";
import AppDossierIntegrationForm from "@/components/accountant/DossierIntegrationForm.vue";

export default Vue.extend({
	data() {
		return {
			exactStatus: {Connected: false} as IExactStatus,
			clearfactsStatus: {Connected: false} as IClearfactsStatus,
			dossier: null as IAccountantDossier | null,
			loading: true
		};
	},
	methods: {
		async load() {
			this.loading = true;
			try {
				let id = parseInt(String(this.$route.params.dossierId), 10) || 0;
				let [status, clearfactsStatus, dossiers] = await Promise.all([
					ExactService.getStatus().catch(() => ({Connected: false} as IExactStatus)),
					ClearfactsService.getStatus().catch(() => ({Connected: false} as IClearfactsStatus)),
					AccountantService.getDossiers()
				]);
				this.exactStatus = status;
				this.clearfactsStatus = clearfactsStatus;
				this.dossier = dossiers.find(d => d.DossierID == id) || null;
			} finally {
				this.loading = false;
			}
		},
		onSaved(updated:IAccountantDossier) {
			this.dossier = updated;
			this.$wf.notify(this.$ct("saved").toString(), "success", 3000, "check");
		}
	},
	mounted() {
		this.load();
	},
	components: {
		AppDossierIntegrationForm
	},
	i18nEx: {
		componentPrefix: "views.AccountantDossierSettings"
	}
});
